import * as React from 'react';

type RefreshContextType = {
  refreshKey: number;
  triggerRefresh: () => void;
};

export const RefreshContext = React.createContext<RefreshContextType>({
  refreshKey: 0,
  triggerRefresh: () => {
    // no-op function
  },
});

export const useRefresh = () => React.useContext(RefreshContext);

type RefreshProviderProps = {
  children: React.ReactNode;
};

export const RefreshProvider: React.FC<RefreshProviderProps> = ({ children }) => {
  const [refreshKey, setRefreshKey] = React.useState(0);

  const triggerRefresh = React.useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  const value = React.useMemo(
    () => ({
      refreshKey,
      triggerRefresh,
    }),
    [refreshKey, triggerRefresh]
  );

  return <RefreshContext.Provider value={value}>{children}</RefreshContext.Provider>;
};
